import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingOperations, OrderingSelectors } from 'polygon-ordering';
import debug from '../utils/debug';
import { logUser } from '../utils/analytics';
import { RootState } from '../store';
import { fetchProfile } from './fetchProfile';
import checkAuthTokenPresent from '../utils/checkAuthTokenPresent';
import { fetchLoyaltyTiers } from './fetchLoyaltyTiers';
import { setUserLogout } from '../slices/userLogout';

const { fetchMember, removeMember } = OrderingOperations;
const { getMember } = OrderingSelectors;

export const syncMember = createAsyncThunk(
  'syncMember',
  async (_data: undefined, { dispatch, getState, rejectWithValue }) => {
    const authPresent = checkAuthTokenPresent();
    debug('syncing member', { authPresent });

    try {
      if (!authPresent) {
        debug('removing member');
        logUser(null);
        dispatch(removeMember());

        return;
      }

      // below are the sign in events 
      dispatch(setUserLogout(false));
      dispatch(fetchProfile());
      dispatch(fetchLoyaltyTiers());

      const previousMemberData = getMember(getState() as RootState);

      await dispatch(fetchMember({ authenticationMethod: 'member' }));

      const newMemberData = getMember(getState() as RootState);

      const signedIn = !previousMemberData && newMemberData;
      const changedUser =
        previousMemberData && newMemberData && previousMemberData.id !== newMemberData.id;

      if ((signedIn || changedUser) && newMemberData) {
        logUser(newMemberData?.memberNumber, newMemberData);
      }

    } catch (e) {
      debug(false, 'member sync failed', { result: e });
      return rejectWithValue(e);
    }
  },
);
